import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { toggleHomeEditActionCreator } from 'actions/settingsActions'
import { NEW_PROPERTY_ID } from 'constants/member'

type HouseEditHandlerProps = {
  homeId?: number
}
export const HouseEditHandler: FC<HouseEditHandlerProps> = (props) => {
  const { children, homeId } = props

  const dispatch = useStoreDispatch()
  const handleClick = useCallback(() => {
    dispatch(toggleHomeEditActionCreator(homeId || NEW_PROPERTY_ID))
    dispatch(modifyFloatingPaneActionCreator('house-edit', {
      homeId,
    }))
  }, [dispatch, homeId])

  return (
    <span onClick={ handleClick }>
      { children }
    </span>
  )
}
